import React from 'react';
import { Layout } from './components/layout';
import './App.scss';

export default function App() {
  return <Layout />;
}
